import React, { Component } from 'react';
import './App.css';
import 'antd/dist/antd.css';
import { debounce } from './util';
import Routes from './routes.js';
import { useQuery, gql } from '@apollo/client';
import Loading from './components/Loading';

const getQueryByLocation = (location) => {
  let query = {};
  if (location.search) {
    let pairs = location.search.split('?')[1].split('&');
    let len = pairs.length;

    for (let i = 0; i < len; i++) {
      let keyVals = pairs[i].split('=');
      query[keyVals[0]] = keyVals[1];
    }
  }

  return query;
};

const getwxQueryByLocation = (location) => {
  let query = {};

  if (location.search) {
    let url = location.search;
    let arrObj = url.split('?');
    if (arrObj.length > 1) {
      var pairs = arrObj[1].split('&');
      let len = pairs.length;

      for (let i = 0; i < len; i++) {
        let keyVals = pairs[i].split('=');
        query[keyVals[0]] = keyVals[1];
      }

      // if (!query['entity']) {
      //   query={}
      // }
    }
  }
  return query;
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      me: props.me || {
        _id: 0,
      },
      width: 1024,
      height: 680,
      isLogin: props.me && props.me._id !== '0' ? true : false,
      query: {},
      wxQuery: {},
    };
  }
  async componentDidMount() {
    const self = this;
    const executor = debounce((self) => {
      if (!self.isUnmount) {
        self.setState({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
    }, 300);

    window.addEventListener('resize', function () {
      if (/Android 4\.[0-3]/.test(navigator.appVersion)) {
        var doc = document;
        if (doc && doc.activeElement.tagName === 'INPUT') {
          window.setTimeout(function () {
            doc.activeElement.scrollIntoViewIfNeeded();
          }, 0);
        }
      }
      executor.execute(self);
    });

    const soj = {
      width: window.innerWidth,
      height: window.innerHeight,
      query: getQueryByLocation(window.location),
      wxQuery: getwxQueryByLocation(window.location),
    };

    this.setState(soj);
  }
  render() {
    const self = this;
    const location = {
      ...this.props.location,
    };
    let newLocation = {
      ...location,
      query: {},
    };
    if (location.search) {
      let query = {};
      let pairs = location.search.split('?')[1].split('&');
      let len = pairs.length;
      for (let i = 0; i < len; i++) {
        let keyVals = pairs[i].split('=');
        query[keyVals[0]] = decodeURIComponent(keyVals[1]);
      }
      newLocation['query'] = query;
    }

    // improve location
    const childProps = {
      ...this.state,
      location: newLocation,
      updateMe: (isLogin, profile) => {
        self.setState({
          isLogin: isLogin,
          profile: profile,
        });
      },
      updateOrg: (newOrg) => {
        self.setState({
          shop: newOrg,
        });
      },
    };
    return <Routes childProps={childProps} />;
  }
}

export const GET_ME = gql`
  query getMe {
    me {
      _id
      role
      nickname
      avatar
    }
  }
`;

const AppWithMe = (props) => {
  const { loading, error, data } = useQuery(GET_ME);
  if (loading) return <Loading />;
  if (error) return <div className="palg">加载出错啦，错误是:{error}</div>;
  return <App me={data.me} {...props} />;
};

export default AppWithMe;
